import Api3DxService from "../Enovia3DxApi.js";
import initApp from "../../utility/initApp.js";
let URL = "/resources";
class enoviaService extends Api3DxService {
  constructor(path, option) {
    if (!option) option = {};
    super(path, option);
  }
  getCollabspaces() {
    this.path = `${URL}/modeler/pno/person?current=true&select=preferredcredentials&select=collabspaces`;
    return super.get();
  }
  getProjectData(projectId, overrideLevel = null) {
    // Use widget taskLevel preference; default to 1 for lazy-loading (children fetched on demand).
    const taskLevel = overrideLevel !== null ? overrideLevel : (window && window.widget ? window.widget.getValue("taskLevel") || 1 : 1);
    this.path = `${URL}/v1/modeler/projects/${projectId}?isDPMTask=true&rollup=live&isCustomizedEnvironment=false&$include=all&$fields=all&level=${taskLevel}&SecurityContext=${initApp.getCTX()}`;
    return super.get();
  }

  // --- Assignee Methods ---

  // GET assignees for a specific task
  getTaskAssignees(taskId) {
    this.path = `${URL}/v1/modeler/tasks/${taskId}/assignees?SecurityContext=${initApp.getCTX()}`;
    return super.get();
  }



  // ADD new assignees to a task
  addTaskAssignees(taskId, personIds) {
    this.path = `${URL}/v1/modeler/tasks/${taskId}/assignees?SecurityContext=${initApp.getCTX()}`;
    const payload = {
      data: personIds.map(id => ({ id }))
    };
    return super.post(payload);
  }

  // REMOVE assignees from a task — DELETE with body to collection endpoint
  // This method is exhaustive, trying both the Relationship ID (relId) and the 
  // Person Object ID (personOid) across multiple API patterns to ensure removal.
  removeTaskAssignees(taskId, personIds) {
    this.path = `${URL}/v1/modeler/tasks/${taskId}/assignees?SecurityContext=${initApp.getCTX()}`;
    const payload = {
      data: personIds.map(id => ({ id }))
    };
    return super.deleteWithBody(payload);
  }

  // SEARCH for users globally using Apps Management API
  searchUsers(query) {
    this.path = `${URL}/AppsMngt/user?platform=OnPremise&search=${encodeURIComponent(query)}&os=windows&sort=Last%20Name&sort_direction=asc&limit=100`;
    return super.get();
  }

  // GET all members of a project (using the main project API as a fallback)
  getProjectMembers(projectId) {
    this.path = `${URL}/v1/modeler/projects/${projectId}?$include=members&SecurityContext=${initApp.getCTX()}`;
    return super.get();
  }

  // GET all users in the system via Apps Management API (no scope restrictions)
  // Supports offset + limit for pagination. Default limit=100 per page.
  getAllUsers(offset = 0, limit = 100) {
    this.path = `${URL}/AppsMngt/user?platform=OnPremise&offset=${offset}&os=windows&sort=Last%20Name&sort_direction=asc&limit=${limit}`;
    return super.get();
  }

  addDeliverables(taskId, data) {
    this.path = `${URL}/v1/modeler/tasks/${taskId}/deliverables?SecurityContext=${initApp.getCTX()}`;
    return super.post(data);
  }

  getCheckinTicket() {
    this.path = `${URL}/v1/modeler/documents/files/CheckinTicket?SecurityContext=${initApp.getCTX()}`;
    return super.update({});
  }

  createDocument(data) {
    this.path = `${URL}/v1/modeler/documents?SecurityContext=${initApp.getCTX()}`;
    return super.post(data);
  }

  checkinDocumentFile(docId, data) {
    // After document creation, checkin the file to actually attach it
    this.path = `${URL}/v1/modeler/documents/${docId}/files/CheckinTicket?SecurityContext=${initApp.getCTX()}`;
    return super.update(data);
  }

  async uploadToFCS(ticketUrl, jobTicket, file) {
    const formData = new FormData();
    formData.append("__fcs__jobTicket", jobTicket);
    formData.append("file_0", file);

    const response = await fetch(ticketUrl, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`FCS Upload failed: ${response.statusText}`);
    }

    return await response.text();
  }
  promoteTask(taskId, nextState) {
    this.path = `${URL}/v1/modeler/tasks?SecurityContext=${initApp.getCTX()}`;
    // Based on Swagger docs, we must use the bulk update format
    return super.update({
      data: [
        {
          id: taskId,
          dataelements: {
            state: nextState
          }
        }
      ]
    });
  }
  getTaskChildren(taskId, overrideLevel = null) {
    const taskLevel = overrideLevel !== null ? overrideLevel : 1;
    this.path = `${URL}/v1/modeler/tasks/${taskId}?isDPMTask=true&rollup=live&isCustomizedEnvironment=false&$include=all&$fields=all&level=${taskLevel}&SecurityContext=${initApp.getCTX()}`;
    return super.get();
  }
  getTaskDeliverables(taskId) {
    this.path = `${URL}/v1/modeler/tasks/${taskId}/deliverables?SecurityContext=${initApp.getCTX()}`;
    return super.get();
  }
  getDocumentDownloadTicket(docId, options = {}) {
    this.path = `${URL}/v1/modeler/documents/${docId}/files/DownloadTicket?SecurityContext=${initApp.getCTX()}`;
    this.option = { ...this.option, ...options };
    return super.update({});
  }
}
export { enoviaService as default };